// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"112":"a9a7754c","532":"styles","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"112":"e87e5ab6f862c6c558e2","532":"612cdb6e5ee75cc01fad","678":"c07a4ded5dfb6cba6fe3","883":"9be46f1acc9c131fe0de"}[chunkId] + ".js";
};